<template>
  <div class="reel-gallery">
    <GalleryBar :title="gallery.name"
                :hasPriceList="hasPriceList"
                @show-price-list="showPriceList"
                v-if="gallery.name"/>

    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" label="Spinning"/>
    </div>

    <div v-else-if="!mediaList || mediaList.length === 0" class="no-media">
      <p>No media available</p>
    </div>

    <div v-else class="reel-item">
      <div class="d-flex align-items-center">
        <MediaItem :index="0"
                   :media="firstMedia"
                   :gallery="gallery"
                   :favorite-enabled="favoriteEnabled"
                   @toggle-favorite="toggleFavourite"
                   @select="openMedia(0)"/>
        <div class="ml-4 reel-info">
          <b-badge pill class="reel-badge mb-3">{{ $t('gallery.reel.badge') }}</b-badge>
          <h6 class="title">{{ $t('gallery.reel.title') }}</h6>
          <div class="text">{{ $t('gallery.reel.text') }}</div>
        </div>
      </div>


    </div>
    <ModalMediaItem :medias="[firstMedia]"
                    :total-medias="1"
                    :page="1"
                    :pagination-mode="paginationType"
                    :is-paid="activeTab === GALLERY_TAB_TYPE.UNPURCHASED"
                    :gallery-type="gallery.type"
                    :digital-item-id="digitalItemId"
                    :ref="modalMediasGalleryId"
                    :modal-id="modalMediasGalleryId"
                    :gallery="gallery"
                    :favorite-enabled="favoriteEnabled"
                    @add-to-favourites="handleAddToFavourites"
                    @remove-from-favourites="handleRemoveFromFavourites"
                    @load-more="loadMore"/>

    <ModalPriceList :modal-id="modalPriceListId"
                    :event-name="eventName"
                    :currency="currency"
                    :price-list="galleryPriceList"
                    :price-list-img="priceListImg"
                    v-if="hasPriceList"/>
  </div>
</template>

<script>
import BaseDisplayType from './BaseDisplayType.vue'
import GalleryBar from "@/domain/galleryTree/components/GalleryBar.vue";
import ModalPriceList from "@/domain/galleries/modals/ModalPriceList.vue";
import MediaItem from "@/domain/galleryTree/components/MediaItem.vue";
import ModalMediaItem from "@/domain/galleryTree/components/ModaMediaItem.vue";

export default {
  name: 'ReelGallery',
  components: {ModalMediaItem, MediaItem, ModalPriceList, GalleryBar},
  extends: BaseDisplayType,

  computed: {
    displayType() {
      return 'reel'
    },

    paginationType() {
      return 'none' // Reel never shows pagination
    },

    firstMedia() {
      return this.mediaList[0] || {}
    }
  },

  methods: {
    getPaginationSize() {
      return 1 // Reel shows only 1 item
    },

    toggleFavourite(item) {
      if (item.favorite) {
        this.handleRemoveFromFavourites(item.id)
      } else {
        this.handleAddToFavourites(item.id)
      }
    }
  }
}
</script>

